import { LandingPagePro } from './LandingPagePro';
import { LandingPageDTC } from './LandingPageDTC';

/**
 * LandingPage Switcher:
 * Switches between Professional ('pro') and Direct-To-Consumer ('dtc') landing pages
 * based on the compile/build-time environment variable `VITE_LANDING_MODE`.
 */
export function LandingPage() {
  const landingMode = (import.meta.env.VITE_LANDING_MODE || 'pro').toLowerCase().trim();

  if (landingMode === 'dtc' || landingMode === 'consumer') {
    return <LandingPageDTC />;
  }

  return <LandingPagePro />;
}
